<div class="wrapper wrapper-content mtv-themes-page row hide-list-nav-tabs">
    <div class="ibox mainPartPage">
        <div class="ibox-content">
            <div class="row">
                <div class="col-sm-7">
                    <filter [tabHeading]="'Theme'"></filter>
                </div>
                <div class="col-sm-5">
                    <button type="button" class="btn btn-w-m btn-primary pull-right"
                            (click)="adm.isShowThemeModal = true">
                        <i class="fa fa-plus-circle"></i> New Theme
                    </button>
                </div>
            </div>

            <tabs-wrapper>
                <tab-item [tabId]="'themes'">

            <div class="table-responsive"
                 [ngClass]="{'sk-loading': adm.spinnerShow}"
                 [class.overflow-hidden]="adm.emptyRowService.emptyRow.length > 0"
                 *ngIf="adm.themesTotal !== null">
                <table class="table table-striped table-hover footable" *ngIf="adm.themes.length">
                    <thead>
                        <tr [ngClass]="{'noSort': adm.themes.length < 2}">
                            <th (click)="adm.urlService.orderBy('id', $event)" class="footable-sorted">
                                ID <span class="footable-sort-indicator"></span>
                            </th>
                            <th (click)="adm.urlService.orderBy('name', $event)">
                                Theme Name <span class="footable-sort-indicator"></span>
                            </th>
                            <th>Created By</th>
                            <th (click)="adm.urlService.orderBy('createdAt', $event)">
                                Created On <span class="footable-sort-indicator"></span>
                            </th>
                            <th># of Users</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-template ngFor let-item [ngForOf]="adm.themes" let-index="index">
                            <tr [ngClass]="{'footable-odd': (index % 2 === 0)}">
                                <td>{{item.id}}</td>
                                <td class="hint-td">
                                    <hint
                                        [data]="item"
                                        [index]="index"
                                        [parentElementSelector]="'.table-responsive'">
                                    </hint>
                                </td>
                                <td>{{item.createdBy && item.createdBy.fullName || '-'}}</td>
                                <td>{{item.createdAt ? transformDate(item.createdAt) : '-'}}</td>
                                <td>{{item.companies.length}}</td>
                                <td class="td-action-btn">
                                    <div class="input-group">
                                        <div class="input-group-btn btn-in-table">
                                            <button class="btn btn-white btn-xs" (click)="adm.editTheme(item)">
                                                Edit Theme
                                            </button>
                                            <button data-toggle="dropdown"
                                                    class="btn btn-white dropdown-toggle btn-xs"
                                                    aria-expanded="false">
                                                <span class="caret"></span>
                                            </button>
                                            <ul class="dropdown-menu pull-right">
                                                <li (click)="cs.enableTheme(item)"><a>Enable Theme</a></li>
                                                <li (click)="adm.removeTheme(item.id)"><a>Delete</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                        <tr *ngFor="let item of adm.emptyRowService.emptyRow" style="cursor: default;">
                            <td>&nbsp;</td><td></td><td></td><td></td><td></td><td></td>
                        </tr>
                    </tbody>
                </table>
                <h2 *ngIf="adm.themesTotal === 0" class="text-center">Result Not Found</h2>
            </div>

                </tab-item>

            <pagination *ngIf="adm.themesTotal && adm.urlService.queryParams['page'] && !adm.spinnerShow" [total]="adm.themesTotal"></pagination>
            <spinner [spinnerShow]="adm.spinnerShow"></spinner>

            </tabs-wrapper>
        </div>
    </div>
</div>

<theme-modal *ngIf="adm.isShowThemeModal"></theme-modal>



// WEBPACK FOOTER //
// /app/src/app/views/admin/themes/theme-list.component.html